import { Popup as LeafletPopup } from 'leaflet'
import { forwardRef, useCallback } from 'react'
import { Popup as ReactLeafletPopup, PopupProps, useMap } from 'react-leaflet'
import { CloseButton } from '../..'

export const Popup = forwardRef<LeafletPopup, PopupProps>(({ children, ...props }, ref) => {
  const map = useMap()
  const close = useCallback(() => map.closePopup(), [map])

  return (
    <ReactLeafletPopup
      pane='popupPane'
      autoPanPadding={[60, 10]}
      closeButton={false}
      {...props}
      ref={ref}
    >
      <CloseButton className='absolute top-1 right-1' onClick={close} />
      {children}
    </ReactLeafletPopup>
  )
})
